import React, {useEffect, useState} from "react";
import commonHeader from "../../assets/img/commonHeader.png";
import commonBack from "../../assets/img/commonBack.png";
import commonClose from "../../assets/img/commonClose.png";
import {useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import {useTranslation} from "react-i18next";
import commomHeader from "../../assets/img/commonHeader.png";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserDepChargeHistoryPg() {

    const {t} = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [memberInfo, setMemberInfo] = useState("");
    const findMember = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberInfo(response.data)
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (LCAT || SSAT) {
            findMember();
        }
    }, [LCAT, SSAT])

    const [depHistoryList, setDepHistoryList] = useState([]);
    const selectedDepHistory = (() => {
        axios({
            method: 'get',
            url: '/member/selectedDepHistory',
            params: {
                id: memberInfo.id
            }
        })
            .then((response) => {
                const sortedData = response.data.sort((a, b) => b.seqNum - a.seqNum);
                setDepHistoryList(sortedData)
            })
            .catch(() => {
                console.log("예치금 신청내역 조회실패")
            })
    })

    useEffect(() => {
        if (memberInfo.id) {
            selectedDepHistory();
        }
    }, [memberInfo])

    const cancelDepHistoryMsg1 = t(`dchMdMsg1`);
    const cancelDepHistoryMsg2 = t(`dchMdMsg2`);

    const [cancelDepHistorySeqNum, setCancelDepHistorySeqNum] = useState(null);
    const [cancelMsgShow, setCancelMsgShow] = useState(false);
    const openCancelMsgShow = ((seqNum) => {
        setCancelDepHistorySeqNum(seqNum);
        setCancelMsgShow(true);
    })
    const closeCancelMsgShow = (() => {
        setCancelMsgShow(false);
    })

    const cancelDepHistory = ((seqNum) => {
        axios({
            method: 'get',
            url: '/member/cancelDepHistory',
            params: {
                seqNum: seqNum
            }
        })
            .then((response) => {
                setDepHistoryList((currentList) => {
                    return currentList.map(item => {
                        if (item.seqNum === seqNum) {
                            return response.data;
                        } else {
                            return item;
                        }
                    });
                });
                closeCancelMsgShow();
            })
            .catch(() => {
                console.log("예치금신청 취소실패")
            })
    })

    const formatDate = (dateStr) => {
        if (dateStr.length !== 8) return "";
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    }

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-head">
                <div className="up-head-l">
                    <img className="up-head-icon up-invert" src={commomHeader} alt="header"/>
                    <p className="up-head-title">{t(`dchHeader`)}</p>
                </div>
                <div className="up-head-spacer"/>
                <div className="up-head-back" onClick={() => navigate("/UserDepChargePg")}>
                    <img className="up-invert" style={{width: "24px", height: "24px", opacity: "0.7"}} src={commonBack} alt="back"/>
                </div>
            </div>

            <div className="up-list up-scroll-x">
                <div className="up-scroll-inner" style={{minWidth: "780px"}}>
                    <div className="up-thead">
                        <div className="c" style={{width: "5%"}}></div>
                        <div className="c" style={{width: "10%"}}>{t(`dchDate`)}</div>
                        <div className="c" style={{width: "20%"}}>{t(`dchSmallMenu1`)}</div>
                        <div className="c" style={{width: "30%"}}>{t(`dchSmallMenu2`)}</div>
                        <div className="c" style={{width: "20%"}}>{t(`dchSmallMenu3`)}</div>
                        <div className="c" style={{width: "5%"}}>{t(`dchSmallMenu4`)}</div>
                        <div className="c" style={{width: "5%"}}>{t(`dchSmallMenu5`)}</div>
                        <div className="c" style={{width: "5%"}}></div>
                    </div>
                    <div className="up-tbody">
                        {depHistoryList.map((dep, i) => (
                            <div key={i} className="up-trow" style={{cursor: "default"}}>
                                <div className="c sub" style={{width: "5%"}}>{i + 1}</div>
                                <div className="c sub" style={{width: "10%"}}>{formatDate(dep.regDate)}</div>
                                <div className="c" style={{width: "20%"}}>{dep.name}</div>
                                <div className="c" style={{width: "30%"}}>{dep.account}</div>
                                <div className="c" style={{width: "20%", flexDirection: "column", gap: "2px"}}>
                                    <span>{dep && dep?.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{t(`dchPrice`)}</span>
                                    {dep.currency ?
                                        <span style={{fontSize: "12px", color: "var(--up-text-sub)"}}>
                                            <span style={{color: "var(--up-brand-2)"}}>{dep.dollarPrice}</span> {dep.currency}
                                        </span>
                                        :
                                        null
                                    }
                                </div>
                                <div className="c sub" style={{width: "5%"}}>{dep.chargeFl ? t(`st8`) : t(`st9`)}</div>
                                <div className="c" style={{width: "5%"}}>
                                    {dep.status === "0" ?
                                        <span className="font-b" style={{color: "#7C9EDC"}}>{t(`st1`)}</span>
                                        :
                                        dep.status === "1" ?
                                            <span className="font-b" style={{color: "#7BC47F"}}>{t(`st2`)}</span>
                                            :
                                            <span className="font-b" style={{color: "#EB7A85"}}>{t(`st3`)}</span>
                                    }
                                </div>
                                <div className="c" style={{width: "5%"}}>
                                    {dep.status === "0" ?
                                        <img className="up-invert" style={{width: "20px", height: "20px", opacity: "0.7", cursor: "pointer"}}
                                             alt="cancel" src={commonClose} onClick={() => openCancelMsgShow(dep.seqNum)}/>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        ))}
                        {depHistoryList.length === 0 &&
                            <div className="up-empty">{t(`dchHeader`)}</div>
                        }
                    </div>
                </div>
            </div>
            {cancelMsgShow ?
                <MsgSelectModal cancelMsgShow={cancelMsgShow} cancelDepHistoryMsg1={cancelDepHistoryMsg1}
                                cancelDepHistoryMsg2={cancelDepHistoryMsg2}
                                closeCancelMsgShow={closeCancelMsgShow} cancelDepHistory={cancelDepHistory}
                                cancelDepHistorySeqNum={cancelDepHistorySeqNum}/>
                :
                null
            }
        </div>
    )
}

export default UserDepChargeHistoryPg
